function toText(value, fallback = '') {
  if (value === null || value === undefined || value === '') return fallback;
  if (typeof value === 'string' || typeof value === 'number') return String(value);
  if (typeof value === 'object') {
    if (value.name) return String(value.name);
    if (value.title) return String(value.title);
    if (value.slug) return String(value.slug);
  }
  return fallback;
}

function toIconByPriority(priority) {
  const normalized = String(priority || '').toUpperCase();
  if (normalized === 'URGENT' || normalized === 'HIGH') return 'shield';
  if (normalized === 'MEDIUM') return 'tools';
  return 'sync';
}

export function mapApiAnnouncementToCard(announcement) {
  const id = announcement?.id || announcement?._id || '';
  const slug = announcement?.slug || '';
  return {
    id: id || slug || `${toText(announcement?.title, 'announcement')}-${toText(announcement?.createdAt, '0')}`,
    identifier: slug || id,
    icon: toIconByPriority(announcement?.priority),
    title: toText(announcement?.title, 'Announcement'),
    description: toText(announcement?.summary || announcement?.content, ''),
    content: toText(announcement?.content, ''),
    date: toText(announcement?.publishedAt || announcement?.updatedAt || announcement?.createdAt, ''),
    priority: toText(announcement?.priority, 'MEDIUM'),
  };
}

export function mapAnnouncementFormToPayload(values) {
  const allowedRoles = Array.isArray(values.allowedRoles)
    ? values.allowedRoles
    : String(values.allowedRoles || '')
        .split(',')
        .map((role) => role.trim().toUpperCase())
        .filter(Boolean);

  return {
    title: values.title?.trim(),
    summary: values.summary?.trim(),
    content: values.content?.trim(),
    status: 'DRAFT',
    priority: values.priority,
    accessType: values.accessType,
    allowedRoles: values.accessType === 'ROLE_BASED' ? allowedRoles : undefined,
    isPinned: Boolean(values.isPinned),
    startsAt: values.startsAt || undefined,
    endsAt: values.endsAt || undefined,
  };
}
